const OLD = "https://customer-assets.emergentagent.com/job_85938a33-e9d2-4396-b30a-3a2ddc28d1a7/artifacts/";
const NEW = "https://customer-assets-0z36b82j.emergentagent.net/job_85938a33-e9d2-4396-b30a-3a2ddc28d1a7/artifacts/";

const PARTNERS = [
  { name: "Georgs Event GmbH", src: `${OLD}olni3uq6_Georgs%20Logo.png`, href: "https://www.instagram.com/georgs.event.gmbh/" },
  { name: "Kabo Events & Management", src: `${OLD}3glzsf6a_Unbenannt.png`, href: "https://www.kaboevents.de/" },
  { name: "TSG Grömitz", src: `${OLD}cmdu5qog_groemitz-logo-tsg-copyright-tsg.png`, href: "https://www.groemitz.de/" },
  { name: "Apparto", src: `${NEW}ca05cddd76cfb425_Apparto.jpg` },
  { name: "Der Reporter", src: `${NEW}e7718ae29d404384_Der%20Reporter.webp` },
  { name: "Falkenthal Seafood", src: `${NEW}af3cc4f5d8f1c3f0_Falkenthal_Logo_farbig_horizontal.webp` },
  { name: "Friedrichsen", src: `${NEW}9016eebcd72175b0_Friedrichsen.jpg` },
  { name: "Gosch Sylt", src: `${NEW}8c5acb9c2c0d1d0b_Gosch%20Sylt.jpg` },
  { name: "Das Handwerkhaus Grömitz", src: `${NEW}adcd67abd8be5c15_Handwerkhaus_wei%C3%9F.png`, href: "https://das-handwerkhaus-groemitz.de/" },
  { name: "Heinrich Haustechnik", src: `${NEW}8eb4466a6c079cdc_Heinrich-Logo_2025_Piktogramme%2BBegriffe.png` },
  { name: "Hoffmann", src: `${NEW}22a69fdd5b0da8ee_Hoffmann%20Logo.png` },
  { name: "Feriendomizil Hollich", src: `${NEW}c6ba1774259eb49a_Hollich.jpg` },
  { name: "Junge Die Bäckerei", src: `${NEW}025819b8571b6e0a_Konditorei-Junge-Logo.webp` },
  { name: "Fleischerei Meier", src: `${NEW}d781886adadeeacf_Logo%20Fleischerei.png` },
  { name: "La Bodega del Mar", src: `${NEW}a9a886d263d7bca9_Logo%20La%20Bodega.png` },
  { name: "Schönste Ostsee Immobilien", src: `${NEW}686197f23f53a2e3_Logo%20Scho%CC%88nste%20Ostseeimmobilien.webp` },
  { name: "Grömitzer Food Patrol", src: `${NEW}b13363e1891a7b86_logo_food_patrol.jpg` },
  { name: "Von Schönfels", src: `${NEW}b66b68e07fef1cb0_Logo_vSchoenfels_Claim_2015_RGB.jpg` },
  { name: "Seemöwe Hotel & Appartements", src: `${NEW}9102aaafeff7b797_Moewe%20HKS%2041%20N.png` },
  { name: "REWE Haase", src: `${NEW}a262fd8381cd91bc_REWE%20Haase.png` },
  { name: "Stoll Heizung Sanitär Elektro Klima", src: `${NEW}71e5df623d995fc2_Stoll.png` },
  { name: "Hotel Windspiel", src: `${NEW}8e0237fe27828324_Windspiel.jpg` },
  { name: "Bike and More Fahrradverleih Grömitz", src: `${NEW}e8fae992929e9ee5_Bike%20and%20More%20Logo.webp`, href: "https://www.fahrradverleih-groemitz.de/" },
  { name: "AVG-Grömitz Ferienwohnungen & Ferienhäuser", src: `${NEW}eb9c374942ee6d26_AVG%20Logo.webp` },
  { name: "Kontor Business IT & Web", src: `${NEW}8bbdfbaea4deefee_Kontor%20Logo.webp` },
];

export const PartnerLogos = () => (
  <div className="mb-20">
    <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-8 md:gap-x-14 md:gap-y-12 max-w-6xl mx-auto" data-testid="partner-logos">
      {PARTNERS.map((p, i) => {
        const Tag = p.href ? "a" : "div";
        const linkProps = p.href
          ? { href: p.href, target: "_blank", rel: "noopener noreferrer", "aria-label": `${p.name} – Website öffnen` }
          : {};
        return (
          <Tag
            key={p.name}
            {...linkProps}
            className="group w-[40%] sm:w-48 md:w-52 h-24 md:h-28 flex items-center justify-center px-2"
            data-testid={`partner-${i + 1}`}
          >
            <img
              src={p.src}
              alt={p.name}
              loading="lazy"
              className="max-h-full max-w-full object-contain grayscale group-hover:grayscale-0 opacity-60 group-hover:opacity-100 transition-all duration-500"
            />
          </Tag>
        );
      })}
    </div>
  </div>
);
